"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.palettes = void 0;
var echPaletteColorBlind = {
    colors: [
        '#1EA593',
        '#2B70F7',
        '#CE0060',
        '#38007E',
        '#FCA5D3',
        '#F37020',
        '#E49E29',
        '#B0916F',
        '#7B000B',
        '#34130C',
    ],
};
var echPaletteForLightBackground = {
    colors: ['#006BB4', '#017D73', '#F5A700', '#BD271E', '#DD0A73'],
};
var echPaletteForDarkBackground = {
    colors: ['#1BA9F5', '#7DE2D1', '#F990C0', '#F66', '#FFCE7A'],
};
var echPaletteForStatus = {
    colors: [
        '#58BA6D',
        '#6ECE67',
        '#A5E26A',
        '#D2E26A',
        '#EBDF61',
        '#EBD361',
        '#EBC461',
        '#D99D4C',
        '#D97E4C',
        '#D75949',
    ],
};
exports.palettes = {
    echPaletteColorBlind: echPaletteColorBlind,
    echPaletteForLightBackground: echPaletteForLightBackground,
    echPaletteForDarkBackground: echPaletteForDarkBackground,
    echPaletteForStatus: echPaletteForStatus,
};
//# sourceMappingURL=colors.js.map